export default __webpack_public_path__ + "static/media/caps.d54165ba.wav";